import { useEffect, useState } from 'react';

/**
 * Returns true once `active` has stayed true continuously for `delayMs`, and false otherwise.
 *
 * Used to surface a "thinking…" overlay only when a request is genuinely slow — a fast response
 * resolves before the delay elapses, so the overlay never flashes; a slow one (the backend doing
 * its adaptive scoping/coverage work) turns it on so the wait reads as work rather than lag.
 */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!active) {
      setOn(false);
      return;
    }
    const timer = setTimeout(() => setOn(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);
  return on;
}
